import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

const urls = {
  createAdmin: 'admin',
  uploadAdminProfileImage: '/admin/uploadProfileImage',
  uploadAdminDocumentsImage: '/admin/uploadDocuments',
  allAdminUsers: '/admin/getAll',
  getUserByUserName: 'admin/getUserByUserName',
  updateUserStatus: 'admin/updateUserStatus',
  updateUserAccessStatus: 'admin/updateUserAccessStatus',
  partnersResetPassword: 'admin/resetPassword',
  updateLoginTime: 'admin/updateLastLoginTime'
};

export const createAdminApi = createAsyncThunk('serviceplug/createAdmin', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createAdmin}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    return data?.result;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const updateAdminApi = createAsyncThunk('serviceplug/updateAdminApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createAdmin}/${params.userName}`,
      method: 'put',
      data: params
    });
    const data = await response.data;

    return data?.result;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    console.log(err, 'ASdd');
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const uploadAdminProfileImageApi = createAsyncThunk('user/uploadStoreImagesApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.uploadAdminProfileImage}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    if (data && data.result) {
      return data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong');
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const uploadAdminDocumentsImageApi = createAsyncThunk(
  'user/uploadDocumentsImagesApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.uploadAdminDocumentsImage}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getAllAdminUsersApi = createAsyncThunk('serviceplug/getAllAdminUsers', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.allAdminUsers, { params });
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getUserByUserNameApi = createAsyncThunk('serviceplug/getUserByUserNameApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(`${urls.getUserByUserName}`, { params });
    if (!_.isEmpty(response.data?.result)) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const updateUserStatusApi = createAsyncThunk('serviceplug/updateUserStatusApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateUserStatus}`,
      method: 'post',
      data: params
    });
    const data = await response.data?.result;
    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const updateUserAccessStatusApi = createAsyncThunk(
  'serviceplug/updateUserAccessStatusApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.updateUserAccessStatus}`,
        method: 'post',
        data: params
      });
      const data = await response.data?.result;
      return data;
    } catch (err) {
      // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const getPartnersResetPasswordApi = createAsyncThunk(
  'serviceplug/getPartnersResetPasswordApi',
  async (params, thunkApi) => {
    console.log(params, 'dflkmle');
    try {
      const response = await axios.get(urls.partnersResetPassword, { params });
      if (response.data?.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateLoginTimeApi = createAsyncThunk('serviceplug/updateLoginTimeApi', async (params, thunkApi) => {
  console.log(params, 'dflkmle');
  try {
    const response = await axios.get(urls.updateLoginTime, { params });
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});
